export default __webpack_public_path__ + "static/media/001-M-divorcee.c8c00260.svg";